/* eslint-disable @angular-eslint/directive-selector */

import { Directive, TemplateRef } from '@angular/core'

@Directive({
    selector: '[expansionPanelTitle]',
    standalone: false,
})
export class ExpansionPanelTitleDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}
